import axios from "axios";


//for admin portal

const api = axios.create({
  baseURL: "https://zipaccounts.com/app1/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// const api = axios.create({
//   baseURL: "http://192.168.1.7:5000/api",
//   headers: {
//     "Content-Type": "application/json",
//   },
// });



export const registerUser = async (userData) => {
  // Map frontend fields to backend schema
  const payload = {
    fullname: userData.fullName,
    email: userData.email,
    phone: userData.contactNumber,
    company_name: userData.companyName,
    company_address: userData.companyAddress,
    city: userData.cityName,
    demo_type: userData.demoSelection,
    // Optionally add created_by, updated_by, assignedTo if available
  };
  try {
    const response = await api.post("/registrations", payload);
    // const response = await api.post("/register", payload);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
